import buildService, { NoParams } from 'common/utils/build-service'
import { DELETE, GET, PATCH, POST } from 'common/requests'

interface JobTitleIdParams {
  id: string
}

export default buildService<NoParams, unknown, unknown, unknown>({
  type: GET,
  constantsPrefix: 'JOB_TITLES',
  isArray: true,
  http: {
    createApiUrlSuffix: () => '/job_titles',
  },
})

export const postJobTitleService = buildService<NoParams, unknown, unknown, unknown>({
  type: POST,
  constantsPrefix: 'JOB_TITLES',
  http: {
    createApiUrlSuffix: () => {
      return `/job_titles`
    },
  },
})

export const deleteJobTitleService = buildService<JobTitleIdParams, unknown, unknown, unknown>({
  type: DELETE,
  constantsPrefix: 'JOB_TITLES',
  http: {
    createApiUrlSuffix: ({ id }) => {
      return `/job_titles?id=eq.${id}`
    },
  },
})

export const patchJobTitleService = buildService<JobTitleIdParams, unknown, unknown, unknown>({
  type: PATCH,
  constantsPrefix: 'JOB_TITLES',
  http: {
    createApiUrlSuffix: ({ id }) => `/job_titles?id=eq.${id}`,
  },
})
